module.exports = __webpack_public_path__ + "img/rejectedtick.fac0a314.svg";